import { BaseApiRepository } from "@/core/infrastructure/BaseApiRepository";
import { OrdersRepository } from "../domain/repositories/OrdersRepository";
import { OrderCreateRequest, OrderUpdateRequest, ResponseInstruments, ResponseOrder, ResponseOrderKV, ResponsePortfolios, ResponseRates, ResponseShares, ResponseVariableOrder, ResponseVariableOrderKV, VariableOrderCreateRequest, VariableOrderUpdateRequest } from "../domain/entities/OrdersEntity";

export class OrdersApiRepository extends BaseApiRepository implements OrdersRepository {
  async getAllOrders(): Promise<ResponseOrderKV> {
    const result = await this.request<ResponseOrderKV>("/api/orders");
    return result;
  }

  async getOrderById(id: string): Promise<ResponseOrderKV> {
    const result = await this.request<ResponseOrderKV>(`/api/orders/${id}`);
    return result;
  }

  async createOrder(order: OrderCreateRequest): Promise<ResponseOrder> {
    const result = await this.request<ResponseOrder>("/api/orders", {
      method: "POST",
      body: JSON.stringify(order),
    });
    return result;
  }

  async updateOrder(order: OrderUpdateRequest): Promise<ResponseOrder> {
    const result = await this.request<ResponseOrder>(`/api/orders/${order.id}`, {
      method: "PUT",
      body: JSON.stringify(order),
    });
    return result;
  }

  async deleteOrder(id: string): Promise<ResponseOrder> {
    const result = await this.request<ResponseOrder>(`/api/orders/${id}`, {
      method: "DELETE",
    });
    return result;
  }

  async getAllPortfolios(): Promise<ResponsePortfolios> {
    return await this.request<ResponsePortfolios>("/api/portfolios");
  }

  async getAllInstruments(): Promise<ResponseInstruments> {
    return await this.request<ResponseInstruments>("/api/instruments");
  }

  async getAllRates(): Promise<ResponseRates> {
    return await this.request<ResponseRates>("/api/rates");
  }

  async getAllShares(): Promise<ResponseShares> {
    return await this.request<ResponseShares>("/api/shares");
  }

  async getAllVariableOrders(): Promise<ResponseVariableOrderKV> {
    const result = await this.request<ResponseVariableOrderKV>("/api/variable_orders");
    return result;
  }

  async createVariableOrder(order: VariableOrderCreateRequest): Promise<ResponseVariableOrder> {
    const result = await this.request<ResponseVariableOrder>("/api/variable_orders", {
      method: "POST",
      body: JSON.stringify(order),
    });
    return result;
  }

  async updateVariableOrder(order: VariableOrderUpdateRequest): Promise<ResponseVariableOrder> {
    const result = await this.request<ResponseVariableOrder>(`/api/variable_orders/${order.id}`, {
      method: "PUT",
      body: JSON.stringify(order),
    });
    return result;
  }

  async deleteVariableOrder(id: string): Promise<ResponseVariableOrder> {
    const result = await this.request<ResponseVariableOrder>(`/api/variable_orders/${id}`, {
      method: "DELETE",
    });
    return result;
  }
}
